export default {
  // Note: this mixin does will only work if there is a single instance of slide-drawer
  // inside a given component
  data() {
    return {
      // primary show/hide toggle prop - bind to v-model
      showSlideDrawer: false,
      // true will prompt user to before closing when slider title X is clicked
      confirmDismiss: false,
    };
  },
  methods: {
    closeSlideDrawer(confirm, ref = 'slide-drawer') {
      // We want to reuse 'dismiss' logic to have a single code path for managing
      // unsaved changes in user component housed in the slide drawer
      const slideDrawer =
        this.$refs[ref] ||
        this.$children.find(child => child.$options._componentTag === 'slide-drawer');

      if (slideDrawer) {
        if (confirm) {
          slideDrawer.handleDismiss();
        } else {
          slideDrawer.doDismiss();
        }
      }
      this.showSlideDrawer = false;
    },
    openSlideDrawer() {
      this.showSlideDrawer = true;
      this.confirmDismiss = false;
    },
  },
};
